export default __webpack_public_path__ + "static/media/gyan.bb6b6d18.jpg";